import Entity from '../entity' 

export default class Role extends Entity<number>{
    name:string;
    guard_name:string;
    permissions: string[];
}